export interface MeterMapping {
  manufacturer: string;
  model: string;
}

export const meterMappings: MeterMapping[] = [
  { manufacturer: 'ABB', model: 'CDD' },
  { manufacturer: 'ABB', model: 'PVI-3.0/3.6/3.8/4.2-TL-OUTD' },
  { manufacturer: 'ABB', model: 'PVI-5000/6000-TL-OUTD' },
  { manufacturer: 'ABB', model: 'PVS-166-TL-POWER-MODULE-1-US' },
  { manufacturer: 'ABB', model: 'PVS-166-TL-POWER-MODULE-2-US' },
  { manufacturer: 'ABB', model: 'PVS-175-TL-POWER-MODULE-1-US' },
  { manufacturer: 'ABB', model: 'PVS-175-TL-POWER-MODULE-2-US' },
  { manufacturer: 'ABB', model: 'PVS-60-TL-R-US' },
  { manufacturer: 'ABB', model: 'PVS-60-TL-SC-R-US' },
  { manufacturer: 'ABB', model: 'PVS-60-TL-SC-US' },
  { manufacturer: 'ABB', model: 'PVS-60-TL-S-R-US' },
  { manufacturer: 'ABB', model: 'PVS-60-TL-S-US' },
  { manufacturer: 'ABB', model: 'PVS-60-TL-US' },
  { manufacturer: 'ABB', model: 'TRIO-TM-60.0-TL-OUTD-US-480' },
  { manufacturer: 'ABB', model: 'TRIO-TM-60.0-TL-US-480' },
  { manufacturer: 'ABB', model: 'UNO-7.6/8.6-TL-OUTD' },
  { manufacturer: 'ABB', model: 'UNO-DM-3.3-TL-PLUS-US-SB-RA' },
  { manufacturer: 'ABB', model: 'UNO-DM-3.3-TL-PLUS-US-SE-RA' },
  { manufacturer: 'ABB', model: 'UNO-DM-3.3-TL-PLUS-US-SZM-RA' },
  { manufacturer: 'ABB', model: 'UNO-DM-3.3-TL-PLUS-US-SZ-RA' },
  { manufacturer: 'ABB', model: 'UNO-DM-3.8-TL-PLUS-US-SB-RA (240V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-3.8-TL-PLUS-US-SE-RA (240V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-3.8-TL-PLUS-US-SZM-RA (240V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-3.8-TL-PLUS-US-SZ-RA (240V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-4.6-TL-PLUS-US-SB-RA (240V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-4.6-TL-PLUS-US-SE-RA (240V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-4.6-TL-PLUS-US-SZM-RA (240V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-4.6-TL-PLUS-US-SZ-RA (240V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-5.0-TL-PLUS-US-SB-RA' },
  { manufacturer: 'ABB', model: 'UNO-DM-5.0-TL-PLUS-US-SE-RA' },
  { manufacturer: 'ABB', model: 'UNO-DM-5.0-TL-PLUS-US-SZM-RA' },
  { manufacturer: 'ABB', model: 'UNO-DM-5.0-TL-PLUS-US-SZ-RA' },
  { manufacturer: 'ABB', model: 'UNO-DM-5.0-TL-PLUS-US-SZ-RA-U' },
  { manufacturer: 'ABB', model: 'UNO-DM-6.0-TL-PLUS-US-SB-RA (208V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-6.0-TL-PLUS-US-SB-RA (240V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-6.0-TL-PLUS-US-SC-RA (208V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-6.0-TL-PLUS-US-SC-RA (240V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-6.0-TL-PLUS-US-SE-RA (208V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-6.0-TL-PLUS-US-SE-RA (240V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-6.0-TL-PLUS-US-S-XRA (208V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-6.0-TL-PLUS-US-S-XRA (240V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-6.0-TL-PLUS-US-SZM-RA (208V)' },
  { manufacturer: 'ABB', model: 'UNO-DM-6.0-TL-PLUS-US-SZM-RA (240V)' },
  { manufacturer: 'ABB (Power-One)', model: 'RGM-Module-US' },
  { manufacturer: 'ABB/Elster', model: 'AB1' },
  { manufacturer: 'ABB/Elster', model: 'ABS' },
  { manufacturer: 'ABB/Elster', model: 'AlphaPlus - A1D+' },
  { manufacturer: 'ABB/Elster', model: 'AlphaPlus - A1K+' },
  { manufacturer: 'ABB/Elster', model: 'AlphaPlus - A1R+' },
  { manufacturer: 'ABB/Elster', model: 'AlphaPlus - A1T+' },
  { manufacturer: 'ABB/Elster', model: 'AlphaPlus - A1TL+' },
  { manufacturer: 'Accuenergy', model: 'Acuvim II' },
  { manufacturer: 'Accuenergy', model: 'Acuvim IIE' },
  { manufacturer: 'Accuenergy', model: 'Acuvim IIR' },
  { manufacturer: 'Accuenergy', model: 'Acuvim IIW' },
  { manufacturer: 'Accuenergy', model: 'Acuvim-AL' },
  { manufacturer: 'Accuenergy', model: 'Acuvim-BL' },
  { manufacturer: 'Accuenergy', model: 'Acuvim-CL' },
  { manufacturer: 'Accuenergy', model: 'Acuvim-DL' },
  { manufacturer: 'Accuenergy', model: 'Acuvim-EL' },
  { manufacturer: 'Accuenergy', model: 'Acuvim-KL' },
  { manufacturer: 'Accuenergy (Canada) Inc.', model: 'AcuRev 1310' },
  { manufacturer: 'Accuenergy (Canada) Inc.', model: 'AcuRev 1312' },
  { manufacturer: 'Accuenergy (Canada) Inc.', model: 'AcuRev 1313' },
  { manufacturer: 'Accuenergy (Canada) Inc.', model: 'AcuRev 1314' },
  { manufacturer: 'AMETEK Power Instruments', model: 'Ci20' },
  { manufacturer: 'AMETEK Power Instruments', model: 'DPMS X1' },
  { manufacturer: 'AMETEK Power Instruments', model: 'DPMS XL' },
  { manufacturer: 'AMETEK Power Instruments', model: 'DPMS XL+' },
  { manufacturer: 'AMETEK Power Instruments', model: 'DPMS XPQ' },
  { manufacturer: 'AMETEK Power Instruments', model: 'DPMS-PM' },
  { manufacturer: 'AMETEK Power Instruments', model: 'JEMStar' },
  { manufacturer: 'Apparent Energy', model: 'MGI-ID (Insight Display)' },
  { manufacturer: 'Apsystems', model: 'ECU-3' },
  { manufacturer: 'Astropower', model: 'APM2 SunChoice' },
  { manufacturer: 'AU Optronics', model: 'AUO Data Logger' },
  { manufacturer: 'BenQ Solar', model: 'BenQ Data Logger' },
  { manufacturer: 'Brand Electronic', model: '20-1850' },
  { manufacturer: 'Brand Electronic', model: '20-1850CI' },
  { manufacturer: 'Brand Electronic', model: '20-CTR' },
  { manufacturer: 'Brand Electronic', model: '21-1850CI' },
  { manufacturer: 'Brand Electronic', model: '4-1850' },
  { manufacturer: 'Brand Electronic', model: 'ONE Meter' },
  { manufacturer: 'Brand Electronic', model: 'OneMeter' },
  { manufacturer: 'Brultech Research', model: 'ECM-1240' },
  { manufacturer: 'Canadian Solar', model: 'GW-CE-RES-G20' },
  { manufacturer: 'CARLO GAVAZZI', model: 'EM24-DINAV53DIS' },
  { manufacturer: 'CARLO GAVAZZI', model: 'EM24-DINAV53DM1' },
  { manufacturer: 'CARLO GAVAZZI', model: 'EM24-DINAV53DM2' },
  { manufacturer: 'CARLO GAVAZZI', model: 'WM30-96' },
  { manufacturer: 'CARLO GAVAZZI', model: 'WM40-96' },
  { manufacturer: 'Chilicon Power', model: 'CP-100' },
  { manufacturer: 'Continental Control Systems', model: 'RWNC-3D-240-MB' },
  { manufacturer: 'Continental Control Systems', model: 'RWNC-3Y-208-MB' },
  { manufacturer: 'Continental Control Systems', model: 'RWNC-3Y-480-MB' },
  { manufacturer: 'Continental Control Systems', model: 'RWND-3D-240-MB' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNB-3D-240-P' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNB-3D-400-P' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNB-3D-480-P' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNB-3Y-208-P' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNB-3Y-400-P' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNB-3Y-480-P' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNB-3Y-600-P' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3D-240-FT10' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3D-240-MB' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3D-400-FT10' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3D-400-MB' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3D-480-FT10' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3D-480-MB' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3Y-208-FT10' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3Y-208-MB' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3Y-400-FT10' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3Y-400-MB' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3Y-480-FT10' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3Y-480-MB' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3Y-600-FT10' },
  { manufacturer: 'Continental Control Systems', model: 'WattNode WNC-3Y-600-MB' },
  { manufacturer: 'Continental Control Systems', model: 'WND-WR-MB' },
  { manufacturer: 'Current Cost', model: 'Envi CC128' },
  { manufacturer: 'Darfon Electronics', model: 'DDL100' },
  { manufacturer: 'Davidge Controls', model: 'EZ Meter A3131/3' },
  { manufacturer: 'Davidge Controls', model: 'EZ Meter A3133/3' },
  { manufacturer: 'Davidge Controls', model: 'EZ Meter A4231/3' },
  { manufacturer: 'Davidge Controls', model: 'EZ Meter A4233/3' },
  { manufacturer: 'Delta Electronics', model: 'DSS3366-TD' },
  { manufacturer: 'Delta Electronics', model: 'DSS3366-TD-A' },
  { manufacturer: 'Delta Electronics', model: 'SOLIVIA 3.0 NA G4 TL' },
  { manufacturer: 'Delta Electronics', model: 'SOLIVIA 3.8 NA G4 TL' },
  { manufacturer: 'Delta Electronics', model: 'SOLIVIA 5.2 NA G4 TL' },
  { manufacturer: 'Delta Electronics', model: 'SOLIVIA 6.6 NA G4 TL' },
  { manufacturer: 'Delta Electronics', model: 'SOLIVIA 7.6 NA G4 TL' },
  { manufacturer: 'DENT Instruments', model: 'PS24' },
  { manufacturer: 'DENT Instruments', model: 'PS3037' },
  { manufacturer: 'Diehl AKO Stiftung & Co. KG', model: 'PLATINUM Webmaster' },
  { manufacturer: 'Direct Grid Technologies', model: 'AN_Ethernet' },
  { manufacturer: 'Draker Solar Design', model: 'PVDAQ Basic' },
  { manufacturer: 'Draker Solar Design', model: 'PVDAQ Commercial' },
  { manufacturer: 'Eaton', model: 'IQ150' },
  { manufacturer: 'Eaton', model: 'IQ250' },
  { manufacturer: 'Eaton', model: 'IQ260' },
  { manufacturer: 'Eaton', model: 'IQ35M' },
  { manufacturer: 'Eaton', model: 'PXM2250' },
  { manufacturer: 'Eaton', model: 'PXM2260' },
  { manufacturer: 'Eaton', model: 'PXM2270' },
  { manufacturer: 'Eaton Corporation', model: 'PXM1100' },
  { manufacturer: 'Eaton Corporation', model: 'PXM1200' },
  { manufacturer: 'Eaton Corporation', model: 'PXM1300' },
  { manufacturer: 'eGauge Systems', model: 'EG4115????' },
  { manufacturer: 'eGauge Systems', model: 'EG4130????' },
  { manufacturer: 'eGauge Systems', model: 'eG3000' },
  { manufacturer: 'eGauge Systems', model: 'EG3010' },
  { manufacturer: 'eGauge Systems', model: 'eGauge2' },
  { manufacturer: 'EKM Metering', model: 'Omnimeter Pulse UL v.4' },
  { manufacturer: 'EKM Metering', model: 'Omnimeter Pulse v.4' },
  { manufacturer: 'Electro Industries/Gaugetech', model: 'Nexus 1250' },
  { manufacturer: 'Electro Industries/Gaugetech', model: 'Nexus 1252' },
  { manufacturer: 'Electro Industries/Gaugetech', model: 'Nexus 1500' },
  { manufacturer: 'Electro Industries/Gaugetech', model: 'Shark 100' },
  { manufacturer: 'Electro Industries/Gaugetech', model: 'Shark 100 S' },
  { manufacturer: 'Electro Industries/Gaugetech', model: 'Shark 200' },
  { manufacturer: 'Elkor Technologies', model: 'WattsOn 1100-5A' },
  { manufacturer: 'Elkor Technologies', model: 'WattsOn 1100-MCTA' },
  { manufacturer: 'Elkor Technologies', model: 'WattsOn 1100-MCTB' },
  { manufacturer: 'Elkor Technologies', model: 'WattsOn 1200-5A' },
  { manufacturer: 'Elkor Technologies', model: 'WattsOn 1200-MCTA' },
  { manufacturer: 'Elkor Technologies', model: 'WattsOn 1200-MCTB' },
  { manufacturer: 'Elkor Technologies', model: 'WattsOn-1100-mA' },
  { manufacturer: 'Elkor Technologies', model: 'WattsOn-1200-mA' },
  { manufacturer: 'Elkor Technologies', model: 'WattsOn-Mark II' },
  { manufacturer: 'Elster', model: 'A3 Alpha - A3D' },
  { manufacturer: 'Elster', model: 'A3 Alpha - A3K' },
  { manufacturer: 'Elster', model: 'A3 Alpha - A3R' },
  { manufacturer: 'Elster', model: 'A3 Alpha - A3T' },
  { manufacturer: 'Elster', model: 'REX R1S' },
  { manufacturer: 'Elster', model: 'REX R1SD' },
  { manufacturer: 'E-MON', model: 'D-MON 208100 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 208100C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 208100D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 2081600 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 2081600C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 2081600D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 208200 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 208200C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 208200D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 20825 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 20825C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 20825D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 2083200 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 2083200C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 2083200D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 208400 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 208400C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 208400D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 20850 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 20850C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 20850D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 208800 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 208800C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 208800D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 480100 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 480100C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 480100D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 4801600 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 4801600C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 480200 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 480200C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 480200D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 48025 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 48025C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 48025D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 4803200 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 4803200C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 4803200D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 480400 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 480400C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 480400D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 48050 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 48050C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 48050D KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 480800 KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 480800C KIT' },
  { manufacturer: 'E-MON', model: 'D-MON 480800D KIT' },
  { manufacturer: 'E-MON', model: 'E-CON 2120100-SA KIT' },
  { manufacturer: 'E-MON', model: 'E-CON 2120200-SA KIT' },
  { manufacturer: 'E-MON', model: 'E-CON 212025-SA KIT' },
  { manufacturer: 'E-MON', model: 'E-CON 212050-SA KIT' },
  { manufacturer: 'E-MON', model: 'E-CON 2277100-SA KIT' },
  { manufacturer: 'E-MON', model: 'E-CON 22772000-SA KIT' },
  { manufacturer: 'E-MON', model: 'E-CON 227725-SA KIT' },
  { manufacturer: 'E-MON', model: 'E-CON 227750-SA KIT' },
  { manufacturer: 'E-MON', model: 'E-CON 3208100-SA KIT' },
  { manufacturer: 'E-MON', model: 'E-CON 3208200-SA KIT' },
  { manufacturer: 'E-MON', model: 'E-CON 320825-SA KIT' },
  { manufacturer: 'E-MON', model: 'E-CON 320850-SA KIT' },
  { manufacturer: 'Enecsys', model: 'CG-A-US' },
  { manufacturer: 'Enecsys', model: 'GW-EU-RES-G20' },
  { manufacturer: 'Energy Tracking', model: 'WEMM' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-120-D' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-120-DBL' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-120-ND' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-240-D' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-240-DBL' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-240-ND' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-480-D' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-480-DBL' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-480-ND' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-DBL-EFC' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-DBL-EFC-333' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-DBL-EFC-5A' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-DBL-EFC-LC' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-DBL-EFC-LC-PO' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-D-EFC' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-D-EFC-333' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-D-EFC-5A' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-D-EFC-LC' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-ND-EFC' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-ND-EFC-333' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-ND-EFC-5A' },
  { manufacturer: 'Energy Tracking', model: 'WEM-MX-ARV-ND-EFC-LC' },
  { manufacturer: 'ENERNET', model: 'K20' },
  { manufacturer: 'Enphase Energy', model: 'EMU' },
  { manufacturer: 'Enphase Energy', model: 'ENV-IQ-AM1-240' },
  { manufacturer: 'Enphase Energy', model: 'Envoy' },
  { manufacturer: 'Enphase Energy', model: 'ENV-S-AM1-120' },
  { manufacturer: 'Exeltech', model: 'HelioSentry HSA2-1-2-6W300' },
  { manufacturer: 'Exeltech', model: 'HelioSentry HSA2-1-2-6W400' },
  { manufacturer: 'Exeltech', model: 'SolarSentry Model SSA2-1-2-6W300' },
  { manufacturer: 'Exeltech', model: 'SolarSentry Model SSA2-1-2-6W400' },
  { manufacturer: 'Fat Spaniel Technologies', model: 'PV2Web for Beacon M5 inverters' },
  { manufacturer: 'Fat Spaniel Technologies', model: 'PV2Web for SATCON Inverters' },
  { manufacturer: 'Fat Spaniel Technologies', model: 'PV2Web for SMA inverters' },
  { manufacturer: 'Fat Spaniel Technologies', model: 'PV2Web Fronius Direct' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 10.0-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 10.0-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 11.4-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 11.4-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 12.5-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 12.5-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 15.0-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 15.0-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 3.8-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 3.8-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 5.0-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 5.0-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 6.0-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 6.0-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 7.6-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 7.6-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 8.2-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Primo 8.2-1 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo 10.0-3 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo 10.0-3 480' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo 12.0-3 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo 12.5-3 480' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo 15.0-3 208' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo 15.0-3 480' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo 17.5-3 480' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo 20.0-3 480' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo 22.7-3 480' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo 24.0-3 480' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo Advanced 10.0-3 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo Advanced 10.0-3 480 Lite' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo Advanced 12.0-3 208-240' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo Advanced 12.0-3 480 Lite' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo Advanced 15.0-3 480' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo Advanced 15.0-3 480 Lite' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo Advanced 20.0-3 480' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo Advanced 20.0-3 480 Lite' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo Advanced 22.7-3 480' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo Advanced 22.7-3 480 Lite' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo Advanced 24.0-3 480' },
  { manufacturer: 'Fronius International GmbH', model: 'Fronius Symo Advanced 24.0-3 480 Lite' },
  { manufacturer: 'Fronius USA', model: 'Fronius Datalogger easy Box' },
  { manufacturer: 'Fronius USA', model: 'Fronius Datalogger easy Card' },
  { manufacturer: 'Fronius USA', model: 'Fronius Datalogger Interface Box' },
  { manufacturer: 'Fronius USA', model: 'Fronius Datalogger pro Box' },
  { manufacturer: 'Fronius USA', model: 'Fronius Datalogger pro Card' },
  { manufacturer: 'Fronius USA', model: 'Fronius Datalogger Web' },
  { manufacturer: 'Fronius USA', model: 'Fronius IG.access' },
  { manufacturer: 'Fronius USA', model: 'FRONIUS IG.online' },
  { manufacturer: 'Fronius USA', model: 'Fronius Interface Box' },
  { manufacturer: 'Fronius USA', model: 'Fronius Interface Card easy' },
  { manufacturer: 'Fronius USA', model: 'Fronius Personal Display' },
  { manufacturer: 'Fronius USA', model: 'Fronius Solar Access' },
  { manufacturer: 'Fronius USA', model: 'Fronius Solar Web' },
  { manufacturer: 'Fronius USA', model: 'LCD Fronius Galvo Series' },
  { manufacturer: 'Fronius USA', model: 'LCD Fronius IG Plus Series' },
  { manufacturer: 'Fronius USA', model: 'LCD Fronius IG Series' },
  { manufacturer: 'GE Energy', model: 'B4001' },
  { manufacturer: 'GE Energy', model: 'B4002' },
  { manufacturer: 'GE Energy', model: 'I70S' },
  { manufacturer: 'GE Energy', model: 'KV' },
  { manufacturer: 'GE Energy', model: 'KV2' },
  { manufacturer: 'GE Energy', model: 'KV2c' },
  { manufacturer: 'GE Energy', model: 'KV2c+' },
  { manufacturer: 'Generac Power Systems Inc.', model: 'W2' },
  { manufacturer: 'General Electric', model: 'EPM2200' },
  { manufacturer: 'General Electric', model: 'EPM6000' },
  { manufacturer: 'General Electric', model: 'EPM9900' },
  { manufacturer: 'General Electric', model: 'I-210+' },
  { manufacturer: 'General Electric', model: 'I-210+C' },
  { manufacturer: 'Global Power Products', model: 'ENER-COMM ECE-100' },
  { manufacturer: 'Global Power Products', model: 'ENER-COMM ECE-200' },
  { manufacturer: 'Global Power Products', model: 'ENER-COMM ECED-100' },
  { manufacturer: 'Global Power Products', model: 'ENER-COMM ECED-200' },
  { manufacturer: 'Home Energy Systems', model: '100 A' },
  { manufacturer: 'Home Energy Systems', model: '25 A' },
  { manufacturer: 'Home Energy Systems', model: '50 A' },
  { manufacturer: 'Huawei Technologies Co., Ltd.', model: 'SUN2000-10KTL-USLO' },
  { manufacturer: 'Huawei Technologies Co., Ltd.', model: 'SUN2000-11.4KTL-USLO' },
  { manufacturer: 'Huawei Technologies Co., Ltd.', model: 'SUN2000-3.8KTL-USLO' },
  { manufacturer: 'Huawei Technologies Co., Ltd.', model: 'SUN2000-5KTL-USLO' },
  { manufacturer: 'Huawei Technologies Co., Ltd.', model: 'SUN2000-7.6KTL-USLO' },
  { manufacturer: 'Huawei Technologies Co., Ltd.', model: 'SUN2000-9KTL-USLO' },
  { manufacturer: 'ICP Solar Technologies', model: 'GreenMeter 61000' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2081000-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL208100-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2081200-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL208200-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL208400-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL208600-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL208800-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL21201000-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2120100-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL21201200-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2120200-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2120400-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2120600-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2120800-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL22771000-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2277100-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL22771200-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2277200-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2277400-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2277600-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2277800-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2401000-GL-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2401000-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL240100-GL-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL240100-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2401200-GL-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL2401200-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL240200-GL-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL240200-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL240400-GL-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL240400-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL240600-GL-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL240600-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL240800-GL-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL240800-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL32081000-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL3208100-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL32081200-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL3208200-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL3208400-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL3208600-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL3208800-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL4801000-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL4801000-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL480100-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL480100-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL4801200-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL4801200-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL480200-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL480200-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL480400-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL480400-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL480600-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL480600-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL480800-L-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'BL480800-PKG-SO' },
  { manufacturer: 'Integrated Metering Systems', model: 'MMD1202001' },
  { manufacturer: 'Integrated Metering Systems', model: 'MMD1202001-SCC' },
  { manufacturer: 'Integrated Metering Systems', model: 'MMD1202001-T' },
  { manufacturer: 'Integrated Metering Systems', model: 'MMD1202001-TSCC' },
  { manufacturer: 'Integrated Metering Systems', model: 'MMS1202001' },
  { manufacturer: 'Integrated Metering Systems', model: 'MMS1202001-SCC' },
  { manufacturer: 'Integrated Metering Systems', model: 'MMS1202001-T' },
  { manufacturer: 'Integrated Metering Systems', model: 'MMS1202001-TSCC' },
  { manufacturer: 'ISAC', model: 'PCMNet' },
  { manufacturer: 'iSYS Systems', model: 'PVM-Net' },
  { manufacturer: 'Itron', model: 'Centron C1S' },
  { manufacturer: 'Itron', model: 'J4S' },
  { manufacturer: 'Itron', model: 'J5S' },
  { manufacturer: 'Itron', model: 'SENTINAL' },
  { manufacturer: 'KACO', model: 'KACO Display' },
  { manufacturer: 'KACO', model: 'KACO Pro Log L' },
  { manufacturer: 'KACO', model: 'KACO Pro Log M' },
  { manufacturer: 'KACO', model: 'KACO Pro Log XL' },
  { manufacturer: 'KACO', model: 'VISO' },
  { manufacturer: 'Kele', model: 'ENG-9000 (EnGenius)' },
  { manufacturer: 'Landis+Gyr', model: 'AL Altimus 2S' },
  { manufacturer: 'Landis+Gyr', model: 'AX Focus' },
  { manufacturer: 'Landis+Gyr', model: 'Focus' },
  { manufacturer: 'Landis+Gyr', model: 'MAXsys Elite' },
  { manufacturer: 'Landis+Gyr', model: 'S4' },
  { manufacturer: 'Landis+Gyr', model: 'S4e' },
  { manufacturer: 'Leviton Manufacturing', model: '7B201-S02' },
  { manufacturer: 'LG Electronics', model: 'LGENBOX-01' },
  { manufacturer: 'Locus Energy', model: 'Lgate 100' },
  { manufacturer: 'Locus Energy', model: 'Lgate 101E' },
  { manufacturer: 'Locus Energy', model: 'LGate 120' },
  { manufacturer: 'Locus Energy', model: 'LGate 320' },
  { manufacturer: 'Locus Energy', model: 'LGate 50' },
  { manufacturer: 'Lovato Electric', model: 'DMG 800' },
  { manufacturer: 'Measurlogic', model: 'DTS 305' },
  { manufacturer: 'Measurlogic', model: 'DTS 307' },
  { manufacturer: 'Measurlogic', model: 'DTS 310' },
  { manufacturer: 'Measurlogic', model: 'DTS DC' },
  { manufacturer: 'Measurlogic', model: 'DTS SKT' },
  { manufacturer: 'Measurlogic', model: 'DTS SKTD' },
  { manufacturer: 'Measurlogic', model: 'DTS SMX' },
  { manufacturer: 'Measurlogic', model: 'DTS SMX' },
  { manufacturer: 'MelRok', model: 'ESP Touch Pro (EMG-1212)' },
  { manufacturer: 'MelRok', model: 'ESP Touch Pro (EMG-2412)' },
  { manufacturer: 'Metrum Technologies', model: 'Landis+Gyr Focus' },
  { manufacturer: 'Microtrend Technologies', model: 'SEA-1' },
  { manufacturer: 'MidNite Solar', model: 'Classic 150' },
  { manufacturer: 'MidNite Solar', model: 'Classic 200' },
  { manufacturer: 'MidNite Solar', model: 'Classic 250' },
  { manufacturer: 'natcon7', model: 'PMRS' },
  { manufacturer: 'Northern Electric & Power Co.', model: 'BDG-256' },
  { manufacturer: 'Northern Electric & Power Co.', model: 'BDG-256P3' },
  { manufacturer: 'OutBack Power Technologies', model: 'Mate' },
  { manufacturer: 'Outback Power Technologies', model: 'Mate 3' },
  { manufacturer: 'Outback Power Technologies', model: 'SBX5048-120/240' },
  { manufacturer: 'Pacific Solar', model: 'Sunlogger' },
  { manufacturer: 'Petra Solar', model: 'S200-V120-Z00D1-300' },
  { manufacturer: 'Phoenix Contact', model: 'EEM-MA200' },
  { manufacturer: 'Phoenix Contact', model: 'EEM-MA250' },
  { manufacturer: 'Phoenix Contact', model: 'EEM-MA400' },
  { manufacturer: 'Phoenix Contact', model: 'EEM-MA600' },
  { manufacturer: 'Poobah Industries', model: 'SB-001' },
  { manufacturer: 'Power Measurement', model: 'ION 6200' },
  { manufacturer: 'Power Measurement', model: 'ION 7330' },
  { manufacturer: 'Power Measurement', model: 'ION 7350' },
  { manufacturer: 'Power Measurement', model: 'ION 7550' },
  { manufacturer: 'Power Measurement', model: 'ION 7650' },
  { manufacturer: 'Power Measurement', model: 'ION 8600' },
  { manufacturer: 'Power Standards Lab', model: 'PQube 3' },
  { manufacturer: 'Power Standards Lab', model: 'PQube 3e' },
  { manufacturer: 'Powerhouse Dynamics', model: 'eMonitor4' },
  { manufacturer: 'Power-One', model: 'CDD' },
  { manufacturer: 'Power-One', model: 'PVI-10.0-I-OUTD-S2-US-208-NG-Z' },
  { manufacturer: 'Power-One', model: 'PVI-10.0-I-OUTD-S2-US-480-NG-Z' },
  { manufacturer: 'Power-One', model: 'PVI-10.0-I-OUTD-S-US-208-NG-Z' },
  { manufacturer: 'Power-One', model: 'PVI-10.0-I-OUTD-S-US-480-NG-Z' },
  { manufacturer: 'Power-One', model: 'PVI-3.0-OUTD-S-US-Z' },
  { manufacturer: 'Power-One', model: 'PVI-3.6-OUTD-S-US-Z' },
  { manufacturer: 'Power-One', model: 'PVI-3.8-I-OUTD-S-US-NG-Z' },
  { manufacturer: 'Power-One', model: 'PVI-4.2-OUTD-S-US-Z' },
  { manufacturer: 'Power-One', model: 'PVI-4.6-I-OUTD-S-US-NG-Z' },
  { manufacturer: 'Power-One', model: 'PVI-5000-OUTD-US-Z' },
  { manufacturer: 'Power-One', model: 'PVI-6000-OUTD-US-Z' },
  { manufacturer: 'Power-One', model: 'PVI-CENTRAL-100-US' },
  { manufacturer: 'Power-One', model: 'PVI-CENTRAL-250-US' },
  { manufacturer: 'Power-One', model: 'PVI-CENTRAL-300-US' },
  { manufacturer: 'Power-One', model: 'PVI-CENTRAL-50-US' },
  { manufacturer: 'Power-One', model: 'TRIO-20.0-TL-OUTD-US-480' },
  { manufacturer: 'Power-One', model: 'TRIO-27.6-TL-OUTD-US-480' },
  { manufacturer: 'Power-One', model: 'ULTRA-1100-TL-OUTD-1-US-690-x-y-z' },
  { manufacturer: 'Power-One', model: 'ULTRA-1100-TL-OUTD-2-US-690-x-y-z' },
  { manufacturer: 'Power-One', model: 'ULTRA-1100-TL-OUTD-3-US-690-x-y-z' },
  { manufacturer: 'Power-One', model: 'ULTRA-1100-TL-OUTD-4-US-690-x-y-z' },
  { manufacturer: 'Power-One', model: 'ULTRA-1500-TL-OUTD-1-US-690-x-y-z' },
  { manufacturer: 'Power-One', model: 'ULTRA-1500-TL-OUTD-2-US-690-x-y-z' },
  { manufacturer: 'Power-One', model: 'ULTRA-1500-TL-OUTD-3-US-690-x-y-z' },
  { manufacturer: 'Power-One', model: 'ULTRA-1500-TL-OUTD-4-US-690-x-y-z' },
  { manufacturer: 'Power-One', model: 'ULTRA-750-TL-OUTD-1-US-690-x-y-z' },
  { manufacturer: 'Power-One', model: 'ULTRA-750-TL-OUTD-2-US-690-x-y-z' },
  { manufacturer: 'Power-One', model: 'ULTRA-750-TL-OUTD-3-US-690-x-y-z' },
  { manufacturer: 'Power-One', model: 'ULTRA-750-TL-OUTD-4-US-690-x-y-z' },
  { manufacturer: 'Power-One', model: 'UNO-2.0-I-OUTD-US' },
  { manufacturer: 'Power-One', model: 'UNO-2.5-I-OUTD-US' },
  { manufacturer: 'PV Powered', model: 'PVM1010' },
  { manufacturer: 'Quadlogic', model: 'MC-5/MC-5c' },
  { manufacturer: 'Quadlogic', model: 'RSM-5/RSM-5c' },
  { manufacturer: 'Quadlogic', model: 'S-10' },
  { manufacturer: 'Quadlogic', model: 'S-20' },
  { manufacturer: 'Real Goods Solar', model: 'PVwatch' },
  { manufacturer: 'REC Solar', model: 'REC Solar Wireless Display' },
  { manufacturer: 'Renesola', model: 'Replus MRG' },
  { manufacturer: 'Renesola', model: 'Replus-250A' },
  { manufacturer: 'Renesola', model: 'Replus-250B' },
  { manufacturer: 'Righthand Engineering', model: 'WinVerter-Monitor' },
  { manufacturer: 'Righthand Engineering', model: 'WinVerter-Monitor FX-MX' },
  { manufacturer: 'SATEC INC', model: 'BFM II' },
  { manufacturer: 'SATEC INC', model: 'BFM136' },
  { manufacturer: 'SATEC INC', model: 'EM133' },
  { manufacturer: 'SATEC INC', model: 'eXpertmeter EM920' },
  { manufacturer: 'SATEC INC', model: 'PM130EH PLUS' },
  { manufacturer: 'SATEC INC', model: 'PM130P PLUS' },
  { manufacturer: 'SATEC INC', model: 'PM172E-N' },
  { manufacturer: 'Schneider Electric', model: 'E5600' },
  { manufacturer: 'Schneider Electric', model: 'EM35' },
  { manufacturer: 'Schneider Electric', model: 'Energy Meter' },
  { manufacturer: 'Schneider Electric', model: 'HDM 1-Meter and 4-Meter' },
  { manufacturer: 'Schneider Electric', model: 'HDM 8-Meter and 16-Meter' },
  { manufacturer: 'Schneider Electric', model: 'ION 6200' },
  { manufacturer: 'Schneider Electric', model: 'ION 7330' },
  { manufacturer: 'Schneider Electric', model: 'ION 7350' },
  { manufacturer: 'Schneider Electric', model: 'ION 7550' },
  { manufacturer: 'Schneider Electric', model: 'ION 7650' },
  { manufacturer: 'Schneider Electric', model: 'ION 8600' },
  { manufacturer: 'Schneider Electric', model: 'ION 8650' },
  { manufacturer: 'Schneider Electric', model: 'ION7400' },
  { manufacturer: 'Schneider Electric', model: 'PM 700 Power Meter' },
  { manufacturer: 'Schneider Electric', model: 'PM 800 Power Meter' },
  { manufacturer: 'Schneider Electric', model: 'PM5000' },
  { manufacturer: 'Schneider Electric', model: 'Series 3000 Circuit Monitor' },
  { manufacturer: 'Schneider Electric', model: 'Series 4000 Circuit Monitor' },
  { manufacturer: 'Schuco USA L.P.', model: 'Sunny Beam' },
  { manufacturer: 'Schuco USA L.P.', model: 'Sunny WebBox' },
  { manufacturer: 'Schweitzer Engineering Laboratories', model: 'SEL-735' },
  { manufacturer: 'Senva Sensors Inc', model: 'EM-PULSE' },
  { manufacturer: 'Senva Sensors Inc', model: 'EM-RS485' },
  { manufacturer: 'Siemens Industry Inc.', model: 'US2:SEM3CAB[5;10;20]FT' },
  { manufacturer: 'Siemens Industry Inc.', model: 'US2:SEM3CAB[6,12,24,36]INCH' },
  { manufacturer: 'Siemens Industry Inc.', model: 'US2:SEM3CONTROLLER' },
  { manufacturer: 'Siemens Industry Inc.', model: 'US2:SEM3PHAMETER' },
  { manufacturer: 'Siemens Industry Inc.', model: 'US2:SEM3PLAMETER' },
  { manufacturer: 'Siemens Industry Inc.', model: 'US2:SEM3RACK3;6;9;15;21' },
  { manufacturer: 'Siemens Industry Inc.', model: 'US2:SEM3TOUCHP7;9,12,15,19' },
  { manufacturer: 'SMA America', model: 'RGM05KIT-US-10' },
  { manufacturer: 'SMA America', model: 'SB3.0-1SP-US-40 (208V)' },
  { manufacturer: 'SMA America', model: 'SB3.0-1SP-US-40 (240V)' },
  { manufacturer: 'SMA America', model: 'SB3.0-1SP-US-41 [208V]' },
  { manufacturer: 'SMA America', model: 'SB3.0-1SP-US-41 [240V]' },
  { manufacturer: 'SMA America', model: 'SB3.0-1TP-US-40 (208V)' },
  { manufacturer: 'SMA America', model: 'SB3.0-1TP-US-40 (240V)' },
  { manufacturer: 'SMA America', model: 'SB3.8-1SP-US-40 (208V)' },
  { manufacturer: 'SMA America', model: 'SB3.8-1SP-US-40 (240V)' },
  { manufacturer: 'SMA America', model: 'SB3.8-1SP-US-41 [208V]' },
  { manufacturer: 'SMA America', model: 'SB3.8-1SP-US-41 [240V]' },
  { manufacturer: 'SMA America', model: 'SB3.8-1TP-US-40 (208V)' },
  { manufacturer: 'SMA America', model: 'SB3.8-1TP-US-40 (240V)' },
  { manufacturer: 'SMA America', model: 'SB5.0-1SP-US-40 (208V)' },
  { manufacturer: 'SMA America', model: 'SB5.0-1SP-US-40 (240V)' },
  { manufacturer: 'SMA America', model: 'SB5.0-1SP-US-41 [208V]' },
  { manufacturer: 'SMA America', model: 'SB5.0-1SP-US-41 [240V]' },
  { manufacturer: 'SMA America', model: 'SB5.0-1TP-US-40 (208V)' },
  { manufacturer: 'SMA America', model: 'SB5.0-1TP-US-40 (240V)' },
  { manufacturer: 'SMA America', model: 'SB6.0-1SP-US-40 (208V)' },
  { manufacturer: 'SMA America', model: 'SB6.0-1SP-US-40 (240V)' },
  { manufacturer: 'SMA America', model: 'SB6.0-1SP-US-41 [208V]' },
  { manufacturer: 'SMA America', model: 'SB6.0-1SP-US-41 [240V]' },
  { manufacturer: 'SMA America', model: 'SB6.0-1TP-US-40 (208V)' },
  { manufacturer: 'SMA America', model: 'SB6.0-1TP-US-40 (240V)' },
  { manufacturer: 'SMA America', model: 'SB7.0-1SP-US-40 (208V)' },
  { manufacturer: 'SMA America', model: 'SB7.0-1SP-US-40 (240V)' },
  { manufacturer: 'SMA America', model: 'SB7.0-1SP-US-41 [208V]' },
  { manufacturer: 'SMA America', model: 'SB7.0-1SP-US-41 [240V]' },
  { manufacturer: 'SMA America', model: 'SB7.0-1TP-US-40 (208V)' },
  { manufacturer: 'SMA America', model: 'SB7.0-1TP-US-40 (240V)' },
  { manufacturer: 'SMA America', model: 'SB7.7-1SP-US-40 (208V)' },
  { manufacturer: 'SMA America', model: 'SB7.7-1SP-US-40 (240V)' },
  { manufacturer: 'SMA America', model: 'SB7.7-1SP-US-41 [208V]' },
  { manufacturer: 'SMA America', model: 'SB7.7-1SP-US-41 [240V]' },
  { manufacturer: 'SMA America', model: 'SB7.7-1TP-US-40 (208V)' },
  { manufacturer: 'SMA America', model: 'SB7.7-1TP-US-40 (240V)' },
  { manufacturer: 'SMA America', model: 'SBS3.8-US-10' },
  { manufacturer: 'SMA America', model: 'SBS5.0-US-10' },
  { manufacturer: 'SMA America', model: 'SBS6.0-US-10' },
  { manufacturer: 'SMA America', model: 'SC-Meter' },
  { manufacturer: 'SMA America', model: 'STP 12000TL-US-10' },
  { manufacturer: 'SMA America', model: 'STP 15000TL-US-10' },
  { manufacturer: 'SMA America', model: 'STP 20000TL-US-10' },
  { manufacturer: 'SMA America', model: 'STP 24000TL-US-10' },
  { manufacturer: 'SMA America', model: 'STP 30000TL-US-10' },
  { manufacturer: 'SMA America', model: 'Sunny Beam' },
  { manufacturer: 'SMA America', model: 'Sunny Boy Control' },
  { manufacturer: 'SMA America', model: 'Sunny Boy Control Light' },
  { manufacturer: 'SMA America', model: 'Sunny Boy Control Plus' },
  { manufacturer: 'SMA America', model: 'Sunny Boy Control Plus-485' },
  { manufacturer: 'SMA America', model: 'Sunny Boy Control-485' },
  { manufacturer: 'SMA America', model: 'Sunny Data' },
  { manufacturer: 'SMA America', model: 'Sunny Data Control' },
  { manufacturer: 'SMA America', model: 'Sunny Multigate (MULTIGATE-US-10)' },
  { manufacturer: 'SMA America', model: 'Sunny WebBox' },
  { manufacturer: 'SMA America', model: 'SWR LCD' },
  { manufacturer: 'SmartSynch', model: 'Itron CENTRON GPRS SmartMeter' },
  { manufacturer: 'SOCOMEC', model: '48290101 / DIRIS Digiware C-31' },
  { manufacturer: 'SOCOMEC', model: '48290102 / DIRIS Digiware U-30' },
  { manufacturer: 'SOCOMEC', model: '48290103 / DIRIS Digiware C-32' },
  { manufacturer: 'SOCOMEC', model: '48290105 / DIRIS Digiware U-10' },
  { manufacturer: 'SOCOMEC', model: '48290106 / DIRIS Digiware U-20' },
  { manufacturer: 'SOCOMEC', model: '48290110 / DIRIS Digiware I-30' },
  { manufacturer: 'SOCOMEC', model: '48290111 / DIRIS Digiware I-31' },
  { manufacturer: 'SOCOMEC', model: '48290112 / DIRIS Digiware I-60' },
  { manufacturer: 'SOCOMEC', model: '48290113 / DIRIS Digiware I-61' },
  { manufacturer: 'SOCOMEC', model: '48290128 / DIRIS Digiware I-33' },
  { manufacturer: 'SOCOMEC', model: '48290129 / DIRIS Digiware I-43' },
  { manufacturer: 'SOCOMEC', model: '48290130 / DIRIS Digiware I-35' },
  { manufacturer: 'SOCOMEC', model: '48290131 / DIRIS Digiware I-45' },
  { manufacturer: 'SOCOMEC', model: 'DIRIS A10' },
  { manufacturer: 'SOCOMEC', model: 'DIRIS A20' },
  { manufacturer: 'SOCOMEC', model: 'DIRIS A40' },
  { manufacturer: 'SOCOMEC', model: 'DIRIS B-10' },
  { manufacturer: 'SOCOMEC', model: 'DIRIS B-30' },
  { manufacturer: 'Solar Integrated Technologies', model: 'REM-ESA-ASSURE' },
  { manufacturer: 'Solar Integrated Technologies', model: 'REM-PBI-ASSURE' },
  { manufacturer: 'Solar Integrated Technologies', model: 'REM-UTILITY-ASSURE' },
  { manufacturer: 'SolarBridge Technologies', model: 'Power Manager' },
  { manufacturer: 'SolarEdge', model: 'SE10000A-US' },
  { manufacturer: 'SolarEdge', model: 'SE10kUS' },
  { manufacturer: 'SolarEdge', model: 'SE11400A-US' },
  { manufacturer: 'SolarEdge', model: 'SE20kUS' },
  { manufacturer: 'SolarEdge', model: 'SE3000A-US' },
  { manufacturer: 'SolarEdge', model: 'SE3000H-US' },
  { manufacturer: 'SolarEdge', model: 'SE3000H-US' },
  { manufacturer: 'SolarEdge', model: 'SE3800A-US' },
  { manufacturer: 'SolarEdge', model: 'SE3800H-US' },
  { manufacturer: 'SolarEdge', model: 'SE3800H-US' },
  { manufacturer: 'SolarEdge', model: 'SE5000A-US' },
  { manufacturer: 'SolarEdge', model: 'SE5000H-US' },
  { manufacturer: 'SolarEdge', model: 'SE5000H-US' },
  { manufacturer: 'SolarEdge', model: 'SE6000A-US' },
  { manufacturer: 'SolarEdge', model: 'SE6000H-US' },
  { manufacturer: 'SolarEdge', model: 'SE6000H-US' },
  { manufacturer: 'SolarEdge', model: 'SE7000A-US' },
  { manufacturer: 'SolarEdge', model: 'SE7600A-US' },
  { manufacturer: 'SolarEdge', model: 'SE7600H-US' },
  { manufacturer: 'SolarEdge', model: 'SE7600H-US' },
  { manufacturer: 'SolarEdge', model: 'SE9kUS' },
  { manufacturer: 'SolarEdge Technologies Ltd.', model: 'SE-RGMTR-1D-240C-A' },
  { manufacturer: 'SolarEdge Technologies Ltd.', model: 'SE-RGMTR-3D-208V-A' },
  { manufacturer: 'SolarEdge Technologies Ltd.', model: 'SE-RGMTR-3Y-208V-A' },
  { manufacturer: 'SolarEdge Technologies Ltd.', model: 'SE-RGMTR-3Y-480V-A' },
  { manufacturer: 'Solar-Log', model: 'Solar-Log 500/1000 RGM' },
  { manufacturer: 'SolarMagic/National Semiconductor', model: 'RECtrack 1' },
  { manufacturer: 'SolarMagic/National Semiconductor', model: 'RECtrack 2' },
  { manufacturer: 'SolarMagic/National Semiconductor', model: 'RECtrack 3' },
  { manufacturer: 'SolarQuest', model: 'rMeter' },
  { manufacturer: 'SolarWorld', model: 'STL 200' },
  { manufacturer: 'SolarWorld', model: 'STL 400' },
  { manufacturer: 'SolarWorld', model: 'STL 800' },
  { manufacturer: 'Solectria Renewables', model: 'LCD PVI 13/15kW' },
  { manufacturer: 'Solectria Renewables', model: 'LCD PVI 1800-2500' },
  { manufacturer: 'Solectria Renewables', model: 'LCD PVI 3000-5300' },
  { manufacturer: 'Solectria Renewables', model: 'LCD PVI 60/82/95kW' },
  { manufacturer: 'Solectria Renewables', model: 'SolrenView 1PH REV' },
  { manufacturer: 'Solectria Renewables', model: 'SolrenView 1PH REV-panel' },
  { manufacturer: 'Solectria Renewables', model: 'SolrenView 3PH 200A REV' },
  { manufacturer: 'Solectria Renewables', model: 'SolrenView 3PH 400A REV' },
  { manufacturer: 'Solectria Renewables', model: 'SolrenView 3PH 800A REV' },
  { manufacturer: 'Solectria Renewables', model: 'SolrenView Inverter Direct' },
  { manufacturer: 'Southwest Windpower', model: 'Skystream 3.7' },
  { manufacturer: 'Sungrow Power Supply', model: 'SG125HV (600V)' },
  { manufacturer: 'SunPower', model: 'ACPV Supervisor' },
  { manufacturer: 'SunPower', model: 'PVS5X' },
  { manufacturer: 'SunPower', model: 'SMS SPRf Series' },
  { manufacturer: 'SunPower', model: 'SMS SPRm Series' },
  { manufacturer: 'SunPower', model: 'SMS SPRx Series' },
  { manufacturer: 'swebs / mysolarstats', model: 'HEM' },
  { manufacturer: 'TE Connectivity/Crompton Instruments', model: 'Integra 1530' },
  { manufacturer: 'TE Connectivity/Crompton Instruments', model: 'Integra 1540' },
  { manufacturer: 'TE Connectivity/Crompton Instruments', model: 'Integra 1560' },
  { manufacturer: 'TE Connectivity/Crompton Instruments', model: 'Integra 1580' },
  { manufacturer: 'TED - The Energy Detective', model: 'TED 5000' },
  { manufacturer: 'TED - The Energy Detective', model: 'TED Pro Series' },
  { manufacturer: 'Thompson Technology Industries', model: 'SunPac' },
  { manufacturer: 'Tigo Energy', model: 'MM-EP and KACO Inverters' },
  { manufacturer: 'Tigo Energy', model: 'MM-EP and SMA inverters' },
  { manufacturer: 'Tigo Energy', model: 'MM-ES and KACO Inverters' },
  { manufacturer: 'Tigo Energy', model: 'MM-ES and SMA inverters' },
  { manufacturer: 'TransData', model: 'MARK-V EMS60' },
  { manufacturer: 'Veris Industries', model: 'E50' },
  { manufacturer: 'Veris Industries', model: 'E51C2' },
  { manufacturer: 'Veris Industries', model: 'E51C3' },
  { manufacturer: 'Veris Industries', model: 'H8030-0100-2' },
  { manufacturer: 'Veris Industries', model: 'H8030-0300-2' },
  { manufacturer: 'Veris Industries', model: 'H8031-0100-2' },
  { manufacturer: 'Veris Industries', model: 'H8031-0300-2' },
  { manufacturer: 'Veris Industries', model: 'H8035-0800-4' },
  { manufacturer: 'Veris Industries', model: 'H8035-100-2' },
  { manufacturer: 'Veris Industries', model: 'H8035-1600-4' },
  { manufacturer: 'Veris Industries', model: 'H8035-2400-4' },
  { manufacturer: 'Veris Industries', model: 'H8035-300-2' },
  { manufacturer: 'Veris Industries', model: 'H8035-400-3' },
  { manufacturer: 'Veris Industries', model: 'H8036-0800-4' },
  { manufacturer: 'Veris Industries', model: 'H8036-100-2' },
  { manufacturer: 'Veris Industries', model: 'H8036-1600-4' },
  { manufacturer: 'Veris Industries', model: 'H8036-2400-4' },
  { manufacturer: 'Veris Industries', model: 'H8036-300-2' },
  { manufacturer: 'Veris Industries', model: 'H8036-400-3' },
  { manufacturer: 'Veris Industries', model: 'H8043-0100-2' },
  { manufacturer: 'Veris Industries', model: 'H8043-0100-2(100A)' },
  { manufacturer: 'Veris Industries', model: 'H8043-0300-2' },
  { manufacturer: 'Veris Industries', model: 'H8043-0300-2(300A)' },
  { manufacturer: 'Veris Industries', model: 'H8043-0800-3' },
  { manufacturer: 'Veris Industries', model: 'H8043-0800-4' },
  { manufacturer: 'Veris Industries', model: 'H8043-400-3' },
  { manufacturer: 'Veris Industries', model: 'H8044-0100-2(100A)' },
  { manufacturer: 'Veris Industries', model: 'H8044-0300-2(300A)' },
  { manufacturer: 'Veris Industries', model: 'H8051-100-2' },
  { manufacturer: 'Veris Industries', model: 'H8051-300-2' },
  { manufacturer: 'Veris Industries', model: 'H8163-0100-0-1' },
  { manufacturer: 'Veris Industries', model: 'H8163-0100-0-2' },
  { manufacturer: 'Veris Industries', model: 'H8163-0100-0-3' },
  { manufacturer: 'Veris Industries', model: 'H8163-01600-4-3' },
  { manufacturer: 'Veris Industries', model: 'H8163-0200-1-1' },
  { manufacturer: 'Veris Industries', model: 'H8163-0200-1-2' },
  { manufacturer: 'Veris Industries', model: 'H8163-0200-1-3' },
  { manufacturer: 'Veris Industries', model: 'H8163-0300-2-1' },
  { manufacturer: 'Veris Industries', model: 'H8163-0300-2-2' },
  { manufacturer: 'Veris Industries', model: 'H8163-0300-2-3' },
  { manufacturer: 'Veris Industries', model: 'H8163-0400-3-2' },
  { manufacturer: 'Veris Industries', model: 'H8163-0400-3-3' },
  { manufacturer: 'Veris Industries', model: 'H8163-0800-3-2' },
  { manufacturer: 'Veris Industries', model: 'H8163-0800-3-3' },
  { manufacturer: 'Veris Industries', model: 'H8163-0800-4-3' },
  { manufacturer: 'Veris Industries', model: 'H8163-2400-4-3' },
  { manufacturer: 'Xantrex', model: 'STRM - Remote Meter' },
  { manufacturer: 'Xantrex', model: 'XW MPPT60' },
  { manufacturer: 'Xantrex', model: 'XW SCP' }
]; 